import { ValidationError } from '@shared/errors';
import React from 'react';

import { bugsnagClient } from '@/lib/bugsnag/bugsnag-client';
import { NotificationConfig, notifyError, notifyWarn } from '@/lib/notification/notifications';

import { ErrorHandlerContext, ErrorSeverity } from './error-handler.context';

const renderValidationMessage = (ex: ValidationError): React.ReactNode => {
  if (ex.messages.length <= 1) return ex.message;
  return (
    <ul className="m-0 list-disc pl-5">
      {ex.messages.map((msg, i) => <li key={i}>{msg}</li>)}
    </ul>
  );
};

export const ErrorHandlerProvider = ({ children }: ErrorHandlerProviderProps) => {

  const handleError = (ex: Error, notificationConfig: NotificationConfig, severity: ErrorSeverity = 'error') => {
    if (ex instanceof ValidationError) {
      const config = { ...notificationConfig, message: renderValidationMessage(ex) };
      if (severity === 'warn') {
        notifyWarn(config);
      } else {
        notifyError(config);
      }
    } else {
      bugsnagClient.notify(ex);
      if (severity === 'warn') {
        notifyWarn(notificationConfig);
      } else {
        notifyError(notificationConfig);
      }
    }
  };

  return (
    <ErrorHandlerContext.Provider value={{ handleError }}>
      {children}
    </ErrorHandlerContext.Provider>
  );
};

type ErrorHandlerProviderProps = {
  children?: React.ReactNode
};
